import { PageConstant } from 'src/app/constant/page.constant';
import {
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
    templateUrl: '../../../template/noop.template.html',
    selector: 'app-apperror-layout',
    standalone: false
})
export class AppErrorLayoutComponent implements OnInit {
  @Output() eventEmit: EventEmitter<string> = new EventEmitter<string>();

  data: {
    ref: ComponentRef<any>;
    currentLanguage: string;
    httpCode: number;
    specificMessageCode: string;
    additionalErrorCode: string;
  };
  version = '';

  constructor() {}

  ngOnInit() {
    this.version = PageConstant.VERSION;
  }

  onCloseClick = (event) => {
    this.eventEmit.emit('close');
  };
}
